import FormsTabs from '../components/FormsTabs';
import React from 'react';
import FormsInbox from '../components/FormsInbox';
import { useAuth } from '../context/AuthContext';

export default function FormsInboxPage() {
  const { terms } = useAuth();
  return (
    <div style={{ padding: '24px 32px', maxWidth: 1100, margin: '0 auto' }}>
      <FormsTabs active="inbox" title="Inbox" />
      <FormsInbox limit={50} showFilter={true} compact={false} />
    </div>
  );
}
